export default __webpack_public_path__ + "static/media/txt.817e4500.svg";